export default {
  logistics: {
    logisticsView: {
      logisticsViewOrder: '物流入库单',
      baseInformation: '基本信息',
      costFree: '费用',
      priductRowList: '商品行项目',
      costView: '费用详情',
      transportationInformation: '运输信息',
      copyFiles: '打印及附件',
      index: '序号',
      attachmentName: '附件名称',
      gmtCreate: '上传时间',
      createBy: '上传人',
      doShow: '操作',
      downLode: '下载',
      sure: '确 定',
      close: '取 消',
      pleaseGetUp: '撤销',
      submit: '提交',
      downLodeFiles: '下载附件',
      delete: '删除',
      save: '保存',
      exportFiles: '上传附件',
      pleaseAddProudectRow: '请将商品行信息填写完整',
      pleaseAddCostRow: '请将费用详情信息填写完整',
      logisticsReceiptList: '物流入库单查询',
      inboundQuantityNegativeNum: '物流入库数量不能为负数',
    },
    logisticsReceiptList: {
      compareLessZeroFlag: '隐藏小于零',
      compareEqualZeroFlag: '隐藏等于零',
      overSave: '已保存',
      overDoIt: '已执行',
      getUp: '已撤销',
      inboundNo: '物流入库单号',
      inboundType: '物流入库类型',
      inboundStatus: '入库单状态',
      purchaseContractNo: '采购合同号',
      searchTableSpec: '商品',
      inboundDate: '入库日期',
      inboundStartDate: '入库开始日期',
      inboundDepartmentNo: '部门',
      personDepartmentName: '部门名称',
      companyName: '公司',
      personCompanyName: '所属公司',
      inboundEndDate: '入库截至日期',
      salesmanNoList: '业务员',
      personCompanyCode: '公司编码',
      makeOrderPerson: '制单人',
      givePerson: '供应商',
      requistPerson: '委托方',
      warehouseName: '仓库名称',
      shippingInstructionNo: '发货指令号',
      saleType: '经营类型',
      attNum: '有无附件',
      logisticsView: '物流入库单详情',
    },
    logisticsRevise: {
      logisticsRevise: '物流入库单编辑',
    },
    commodityMarket: {
      shippingName: '供应商',
      shippingInstructionNo: '供应商发货指令号',
      instructionDetailNo: '供应商发货指令行项目号',
      returnExchangeNo: '退换货单号',
      returnExchangeRowNo: '退换货单行项目号',
      inventoryAllocationNo: '库存调拨单号',
      inventoryAllocationRowNo: '库存调拨单行项目号',
      productNo: '商品编码',
      productName: '商品描述',
      distributionBatchNo: '物流批次',
      instructionNumber: '业务通知数量',
      inboundQuantity: '物流入库数量',
      inboundUnit: '单位',
      purchaseNo: '采购合同号',
      searchIntentNo: '意向单号',
      puchaseDetailNo: '采购合同行项目号',
      packaging: '包装',
      unitWeight: '单位重量',
      unitNumber: '件数',
      packagingNumber: '包装数量',
      packagingUnit: '包装单位',
      storageNo: '仓库',
      productMark: '备注',
      refundRate: '退税率(%)',
      refundAmount: '退税金额',
      inboundQuantityValidRules: '请输入物流入库数量',
      inboundUnitValidRules: '请输入单位',
      unitWeightValidRules: '请输入单位重量',
      packagingUnitValidRules: '请输入包装单位',
      storageNoValidRules: '请选择仓库',
    },
    costFree: {
      totalExpense: '费用',
      totalExpenseTitle: '请输入信息',
      settleDate: '结算日期',
      settleDateTitle: '请选择日期',
      settlePersonName: '结算人员',
      settleNo: '结算单',
      currencyTypeName: '币种',
      flag: '结算标识',
    },
    detailsOfCharges: {
      expenseType: '费用类型',
      expenseRate: '费率',
      expenseQuantity: '数量',
      totalExpense: '费用',
      expenseTypeValidRules: '请选择费用类型',
      expenseRateValidRules: '请输入费率',
      expenseQuantityValidRules: '请输入数量',
      noSelectMatas: '您还没选择想要删除的数据',
      deleteSuccess: '删除成功!',
      getUpDelete: '已取消删除!',
    },
    transportationInformation: {
      shippingMethod: '运输方式',
      pleaseShippingMethod: '请选择运输方式',
      index: '序号',
      contactInfo: '联系方式',
      identityCardNumber: '身份证号',
      chargePerson: '联系人',
      shippingInfo: '货运信息',
      nameVoyageLicense: '船名/航次/车牌',
    },
    logisticsReceipt: {
      inboundNo: '物流入库单号',
      createDate: '创建日期',
      selectCreateDate: '请选择日期',
      instructionStatus: '入库单状态',
      selectInstructionStatus: '请选择入库状态',
      inboundCreatePerson: '制单人',
      writeInboundCreatePerson: '请输入制单人',
      companyName: '公司',
      writeCompanyName: '请输入公司',
    },
    baseInformation: {
      partnerName: '供应商',
      createDate: '入库日期',
      selectCreateDate: '请选择日期',
      pSelectTableSpec: '请选择仓库',
      searchTableSpec: '仓库',
      inboundType: '物流入库类型',
      pSelect: '请选择',
      pSelectCreateDate: '请选择入库日期',
      professionalQuality: '业务性质',
      requestPerson: '委托方',
      marineBillLadingNumber: '海运提单号',
      totalExpenseTitle: '请输入信息',
      vesselLot: '船名/批次',
      periodAvoidBox: '免箱期至',
      returnSalesmanName: '业务员',
      returnDepartmentCode: '部门',
      returnDepartmentName: '请输入部门',
      mark: '备注',
      lengthError: '名称长度在 3 到 50 个字符',
      outCode: '外部编号',
      shippingMark: '收货备注',
    },
    returnOrderTable: {
      Title: '销售退换货单',
      shippingInstructionNo: '退换货单号',
      returnDepartmentCode: '部门',
      searchTableSpec: '仓库',
      returnType: '性质',
      inboundStorageName: '仓库',
      returnDepartmentName: '部门',
      productDesc: '商品描述',
      returnQuantity: '数量',
      partnerName: '供应商',
      returnSalesmanName: '业务员',
      salesReturn: '销售退货',
      salesExchange: '销售换货',
      creatTranstionOrder: '请勾选至少一个退换货单创建物流入库单',
    },
    searchTable: {
      instructionNo: '供应商发货指令号',
      storageName: '仓库',
      deliverMethod: '发货方式',
      instructionNumber: '发货数量',
      remainingNumber: '剩余数量',
      remainingQuantityIn: '剩余应入数量',
      deliverDate: '发货日期',
      purchaseIntentNo: '意向单号',
      supplierDistribution: '供应商配送',
      selfProduction: '物产自提',
      CustomerSelfMention: '客户自提',
      libraryTurn: '库转',
      creatTranstionOrder: '请勾选至少一个供应商发货指令创建物流入库单',
    },
    stockOrderTable: {
      allot: '选择库存调拨单',
      allotNo: '库存调拨单号',
      allotDateBegin: '调拨日期起',
      allotDateEnd: '调拨日期至',
      searchTableSpec: '调入仓库',
      nameVoyageLicense: '船名航次',
      allotDate: '调拨日期',
      creatTranstionOrder: '请勾选至少一个库存调拨单创建物流入库单',
    },
  },
};
